import React, { useState } from "react";
import "./FeedbackForm.css";

const FeedbackForm = ({ onSubmit }) => {
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (feedback.trim() === "") return;

    if (onSubmit) {
      onSubmit(feedback); // Send feedback to parent/database
    }

    setFeedback("");
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000); // reset message after 3s
  };

  return (
    <div className="feedback-container">
      <p className="feedback-desc">
        Tell us what you think about this unit. Your input helps improve future lessons!
      </p>
      <form onSubmit={handleSubmit} className="feedback-form">
        <textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Write your feedback here..."
          className="feedback-textarea"
        />
        <button type="submit" className="feedback-button">
          Submit Feedback
        </button>
      </form>
      {submitted && <p className="feedback-success">✅ Thank you for your feedback!</p>}
    </div>
  );
};

export default FeedbackForm;
